import React, { useEffect, useState } from "react";
import { getIsMHCName } from "../../../../../utilities/utils";

const ProfessionalSpecialties = ({
  modalities,
  updateUser,
  handleSelectModalities,
  handleSelectSpecialties,
  specialties,
}) => {
  const [selectedModalities, setSelectedModalities] = useState([]);
  const [selectedSpecialties, setSelectedSpecialties] = useState([]);

  useEffect(() => {
    if (updateUser) {
      const modalities = updateUser.modalities?.map((modalities) => {
        return modalities;
      });

      const professionIDs = updateUser.professions?.map((profession) => {
        return profession.id;
      });
      setSelectedModalities(modalities ?? []);
      setSelectedSpecialties(professionIDs ?? []);
    }
  }, [updateUser]);

  // const modalities = ["Individuals", "Family", "Couples", "Children"];
  const preferences = [
    "Children 6-10",
    "Preteens / Tweens 11 - 13",
    "Adolescents / Teenagers 14 -19",
    "Adults",
    "Elderly",
  ];

  const handleSpecialtyCheckboxChange = (option) => {
    if (selectedSpecialties.some((specialtyId) => specialtyId == option.id)) {
      const filteredSpecialties = selectedSpecialties.filter(
        (professionId) => professionId !== option.id
      );
      setSelectedSpecialties(filteredSpecialties);
      handleSelectSpecialties(filteredSpecialties);
    } else {
      setSelectedSpecialties([...selectedSpecialties, option.id]);
      handleSelectSpecialties([...selectedSpecialties, option.id]);
    }
  };

  // Handle checkbox change
  const handleCheckboxChange = (option) => {
    if (selectedModalities.some((modality) => modality.id == option.id)) {
      const filteredModalities = selectedModalities.filter(
        (item) => item.id !== option.id
      );
      setSelectedModalities(filteredModalities);
      handleSelectModalities(filteredModalities);
    } else {
      setSelectedModalities([...selectedModalities, option]);
      handleSelectModalities([...selectedModalities, option]);
    }
  };
  return (
    <div className="border border-solid border-[#EBEFF3] p-5 rounded-md mb-6 bg-white">
      <h5 className="text-base font-bold leading-[160%] text-customGray mb-5">
        {getIsMHCName(updateUser.professions[0])}
      </h5>
      <div>
        <h6 className="text-xs font-bold leading-[160%] text-customGray uppercase mb-[10px]">
          Services Provided
        </h6>
      </div>
      <div className="py-5 border-[#EBEFF3]">
        <div>
          <ul className="grid grid-cols-1 xl:grid-cols-2 gap-3">
            {specialties?.length > 0 &&
              specialties
                .filter((spec) => !spec.form_step_hidden)
                .map((option) => (
                  <li className="form-group flex items-center">
                    <div className="flex items-center relative">
                      <input
                        id={`modalOption-${option.id}`}
                        aria-describedby="comments-description"
                        name={`modalOption-${option.id}`}
                        type="checkbox"
                        checked={selectedSpecialties.some(
                          (profIds) => profIds == option.id
                        )}
                        onChange={() => handleSpecialtyCheckboxChange(option)}
                        className="rounded border border-solid border-[#CCD0D4] relative cursor-pointer inline-block w-5 h-5 leading-[0px]"
                      />
                    </div>
                    <div className="min-w-0 flex-1 text-sm leading-6">
                      <label
                        htmlFor={`modalOption-${option.id}`}
                        className="font-medium text-customGray text-sm md:text-base leading-[160%] pl-[14px] cursor-pointer"
                      >
                        {option.name}
                      </label>
                    </div>
                  </li>
                ))}
          </ul>
        </div>
      </div>

      <div>
        <h6 className="text-xs font-bold leading-[160%] text-customGray uppercase mb-[10px]">
          Modalities Offered
        </h6>
      </div>
      <div className="py-5 border-b border-solid border-[#EBEFF3]">
        <div>
          <ul className="grid grid-cols-1 xl:grid-cols-2 gap-3">
            {modalities?.length > 0 &&
              modalities.map((option) => (
                <li className="form-group flex items-center">
                  <div className="flex items-center relative">
                    <input
                      id={`modalOption-${option.id}`}
                      aria-describedby="comments-description"
                      name={`modalOption-${option.id}`}
                      type="checkbox"
                      checked={selectedModalities.some(
                        (modality) => modality.id == option.id
                      )}
                      onChange={() => handleCheckboxChange(option)}
                      className="rounded border border-solid border-[#CCD0D4] relative cursor-pointer inline-block w-5 h-5 leading-[0px]"
                    />
                  </div>
                  <div className="min-w-0 flex-1 text-sm leading-6">
                    <label
                      htmlFor={`modalOption-${option.id}`}
                      className="font-medium text-customGray text-sm md:text-base leading-[160%] pl-[14px] cursor-pointer"
                    >
                      {option.name}
                    </label>
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
      {/* <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 pt-5">
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-customGray uppercase mb-[10px]">
            Client range preferences
          </h6>
          <p className="text-sm font-normal leading-[160%] text-[#485868] max-w-[332px] w-full">
            Lorem ipsum is placeholder text commonly used in the graphic, print,
            and publishing industries
          </p>
        </div>
        <div>
          <ul className="flex flex-col gap-3">
            {preferences.map((option, index) => (
              <li className="form-group flex items-center">
                <div className="flex items-center relative">
                  <input
                    id={`specialOption-${index}`}
                    aria-describedby="comments-description"
                    name={`specialOption-${index}`}
                    type="checkbox"
                    checked={selectedModalities.includes(option)}
                    onChange={() => handleCheckboxChange(option)}
                    className="rounded border border-solid border-[#CCD0D4] relative cursor-pointer inline-block w-5 h-5 leading-[0px]"
                  />
                </div>
                <div className="min-w-0 flex-1 text-sm leading-6">
                  <label
                    htmlFor={`specialOption-${index}`}
                    className="font-medium text-customGray text-sm md:text-base leading-[160%] pl-[14px] cursor-pointer"
                  >
                    {option}
                  </label>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div> */}
    </div>
  );
};

export default ProfessionalSpecialties;
